import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Parser from "html-react-parser";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import _ from "lodash";

import NormalDialog from "../../../Dialog/NormalDialog";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import AisEditActionItem from "./aisEditActionItem";
import AisAddActionItem from "./aisAddActionItem";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { aisDetailFormStyle } from "../../../../styles/jss/components/AIS/aisDetailFormStyle";
import {
  updateAISActionItem,
  addAISActionItem,
  deleteAISActionItem,
} from "../../../../dataSource/ais";

const useStyles = makeStyles((theme) => aisDetailFormStyle(theme));
const AisActionItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const [selectEditDialogOpen, setSelectEditDialogOpen] = useState(false);
  const [selectAddDialogOpen, setSelectAddDialogOpen] = useState(false);
  const [actionItem, setActionItem] = useState();
  const [tmpAisCatSeq, setTmpAisCatSeq] = useState(null);
  const [addItem, setAddItem] = useState();
  const { item, setUpdateFlag, updateFlag } = props;
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });

  // Build Confirm Dialog
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };
  const selectEditHandleOpen = () => {
    setSelectEditDialogOpen(true);
  };

  const selectEditHandleClose = () => {
    setSelectEditDialogOpen(false);
  };
  const selectAddHandleOpen = () => {
    setSelectAddDialogOpen(true);
  };

  const selectAddHandleClose = () => {
    setSelectAddDialogOpen(false);
  };

  const editActionItemConfirm = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Save Action Item",
      dialogContent: "Are you sure to save this Action Item?",
      confirmAction: () => saveActionItemAction(actionItem),
      cancelAction: cancelAction,
    });
  };

  const addActionItemConfirm = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Add Action Item",
      dialogContent: "Are you sure to add this Action Item?",
      confirmAction: () => addActionItemAction(tmpAisCatSeq),
      cancelAction: cancelAction,
    });
  };

  const saveActionItemAction = (actionItem) => {
    updateAISActionItem(actionItem).then((res) => {
      selectEditHandleClose();
      confirmDialogHandleClose();
      setUpdateFlag(!updateFlag);
    });
  };

  const addActionItemAction = (tmpAisCatSeq) => {
    let body = item.filter((obj) => obj.ais_cat_seq === tmpAisCatSeq);
    let index = body.findIndex(
      (obj) =>
        obj.item_seq == addItem.item_seq && obj.ais_cat_seq == tmpAisCatSeq
    );
    body.splice(index + 1, 0, addItem);
    body = _.union(
      body
        .filter(
          (obj) => Number(obj.item_seq) < addItem.item_seq || obj.flag === "NEW"
        )
        .map((jobj) => {
          return {
            action_item_seq: jobj.action_item_seq,
            ais_cat_seq: jobj.ais_cat_seq,
            title: jobj.title,
            description: jobj.description,
            item_seq: Number(jobj.item_seq),
            targetcompletiondate:
              jobj.targetcompletiondate === undefined
                ? null
                : jobj.targetcompletiondate,

            actionBy: jobj.actionBy,
            notes: jobj.notes,
            status: jobj.status,
            template: jobj.template,
          };
        }),
      body
        .filter(
          (obj) =>
            Number(obj.item_seq) >= addItem.item_seq && obj.flag !== "NEW"
        )
        .map((jobj) => {
          return {
            action_item_seq: jobj.action_item_seq,
            ais_cat_seq: jobj.ais_cat_seq,
            title: jobj.title,
            description: jobj.description,
            item_seq: Number(jobj.item_seq) + 1,
            targetcompletiondate:
              jobj.targetcompletiondate === undefined
                ? null
                : jobj.targetcompletiondate,

            actionBy: jobj.actionBy,
            notes: jobj.notes,
            status: jobj.status,
            template: jobj.template,
          };
        })
    );
    let insertBody = { items: body, bySeq: "Y" };

    addAISActionItem(insertBody).then((res) => {
      selectAddHandleClose();
      confirmDialogHandleClose();
      setUpdateFlag(!updateFlag);
    });
  };

  const cancelAction = () => {
    confirmDialogHandleClose();
  };

  const editDialogBtn = [
    {
      buttonName: "Save",
      buttonFunction: editActionItemConfirm,
    },
    {
      buttonName: "Close",
      buttonFunction: selectEditHandleClose,
    },
  ];
  const addDialogBtn = [
    {
      buttonName: "Save",
      buttonFunction: addActionItemConfirm,
    },
    {
      buttonName: "Close",
      buttonFunction: selectAddHandleClose,
    },
  ];

  const editActionItem = (obj) => {
    setActionItem(obj);
    selectEditHandleOpen();
  };
  const deleteActionItem = (item_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Delete Action Item",
      dialogContent: "Are you sure to delete this Action Item?",
      confirmAction: () => deleteActionItemAction(item_seq),
      cancelAction: cancelAction,
    });
  };
  const deleteActionItemAction = async (item_seq) => {
    await deleteAISActionItem(item_seq).then((res) => {
      confirmDialogHandleClose();
      setUpdateFlag(!updateFlag);
    });
  };
  const addActionItem = (obj) => {
    let addBody = {
      action_item_seq: null,
      ais_cat_seq: obj.ais_cat_seq,
      actionBy: null,
      item_seq: Number(obj.item_seq) + 1,
      title: null,
      notes: null,
      flag: "NEW",
      status: "In Progress",
      description: null,
      template: "N",
      targetcompletiondate: null,
    };
    setAddItem(addBody);
    setTmpAisCatSeq(obj.ais_cat_seq);
    selectAddHandleOpen();
  };
  return (
    <Fragment>
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <NormalDialog
        open={selectEditDialogOpen}
        dialogTitle={`Edit Action Item`}
        formContent={
          <AisEditActionItem
            setSelectEditDialogOpen={setSelectEditDialogOpen}
            actionItem={actionItem}
            updateFlag={updateFlag}
            confirmDialogData={confirmDialogData}
            confirmDialogOpen={confirmDialogOpen}
            setActionItem={setActionItem}
            setUpdateFlag={setUpdateFlag}
          />
        }
        size={"lg"}
        height={850}
        button={editDialogBtn}
        handleClose={selectEditHandleClose}
      />
      <NormalDialog
        open={selectAddDialogOpen}
        dialogTitle={`Add Action Item`}
        formContent={
          <AisAddActionItem
            setSelectAddDialogOpen={setSelectAddDialogOpen}
            addItem={addItem}
            updateFlag={updateFlag}
            confirmDialogData={confirmDialogData}
            confirmDialogOpen={confirmDialogOpen}
            setAddItem={setAddItem}
            setUpdateFlag={setUpdateFlag}
          />
        }
        size={"lg"}
        height={850}
        button={addDialogBtn}
        handleClose={selectAddHandleClose}
      />
      {item.length > 0 && (
        <TableContainer component={Paper}>
          <Table
            className={classes.table}
            size="small"
            aria-label="simple table"
          >
            <TableBody>
              {item.map((obj, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell style={{ width: "75%" }}>
                      {index + 1}. {obj.title}
                      <br />
                      <div style={{ margin: "8px" }}>
                        {obj.description !== null
                          ? Parser(obj.description)
                          : ""}
                        {obj.description !== null && obj.notes !== null && (
                          <hr />
                        )}
                        {obj.notes !== null ? Parser(obj.notes) : ""}
                      </div>
                    </TableCell>
                    <TableCell align="right" style={{ width: "15%" }}>
                      <Tooltip title="Add Action Item Here">
                        <IconButton
                          aria-label="add"
                          className={classes.itemBtn}
                          onClick={() => {
                            addActionItem(obj);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit Action Item">
                        <IconButton
                          aria-label="edit"
                          className={classes.itemBtn}
                          onClick={() => {
                            editActionItem(obj);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      {obj.template === "N" && (
                        <Tooltip title="Delete Action Item">
                          <IconButton
                            aria-label="delete"
                            className={classes.itemBtn}
                            onClick={() => {
                              deleteActionItem(obj.action_item_seq);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Fragment>
  );
};

export default AisActionItem;
